import Joi from '@hapi/joi'

export const sosSearchSchemaObject = {

    groupID: Joi.number().invalid(0).required().label("Group").messages({ "any.invalid": `Group Required`, }),
    operationEntityId: Joi.number().invalid(0).required().label("Operation Entity").messages({ "any.invalid": `Operation Entity Required`, }),
    aspNetUserId: Joi.number().allow(0, null).label("User Name"),
    collectionPointID: Joi.number().allow(0, null).label("Collection Point Name"),

}